module.exports = __webpack_public_path__ + "img/discover.76166fa2.svg";